<template>
  <div>
    <div>
      <p class="ol-tilte">Selecione as opções abaixo:</p>
      <ol>
        <li v-for="(question, index) in questions" :key="`question_${question.key}`" :id="`li_${index}`">
          <div class="d-flex">
            <p class="list-number mb-0">{{ index + 1 }}.</p>
            <p class="question mb-0" :name="question.key">{{ question.text }}</p>
          </div>
          <v-radio-group
            v-model="answers[question.key]"
            :row="$vuetify.breakpoint.smAndUp"
            class="px-3"
            hide-details
            dense
            @change="() => handleBindedQuestionOnChange(question.key, index)"
            :disabled="disabled"
          >
            <v-radio
              v-for="option in getQuestionOptions(question.key)"
              :key="`option_${option.text}`"
              :label="option.text"
              :value="option.value"
            >
            </v-radio>
          </v-radio-group>
          <div v-if="verifyBindedQuestion(question.key)" class="pl-3">
            <p class="question mt-7 ml-2" :name="findBindedQuestion(question.key).key">
              {{ findBindedQuestion(question.key).text }}
            </p>
            <v-radio-group
              v-model="answers[findBindedQuestion(question.key).key]"
              :row="$vuetify.breakpoint.smAndUp"
              hide-details
              dense
              :disabled="disabled"
            >
              <v-radio
                v-for="option in getQuestionOptions(findBindedQuestion(question.key).key)"
                :key="`option_${option.value}`"
                :label="option.text"
                :value="option.value"
              >
              </v-radio>
            </v-radio-group>
          </div>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { isEqual, isNil, set, sum } from 'lodash'

export default {
  name: 'DlqiCalculator',
  props: {
    fillData: {
      type: Object,
      default: () => ({}),
    },
    valid: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      questions: [
        {
          key: 'pele_afetada',
          text: 'O quanto sua pele foi afetada durante a semana que passou por causa de coceira, inflamação, dor ou queimação?',
        },
        {
          key: 'constrangimento',
          text: 'Quanto constrangimento ou outro tipo de limitação foi causado por sua pele durante a semana que passou?',
        },
        {
          key: 'intereferencia_atividades_passeios',
          text: 'O quanto sua pele interferiu nas suas atividades de compras ou passeios, em casa ou em locais públicos, durante a semana que passou?',
        },
        {
          key: 'interferencia_roupa',
          text: 'Até que ponto sua pele interferiu na semana que passou com relação às roupas que você normalmente usa?',
        },
        {
          key: 'atividade_social_lazer_afetado',
          text: 'O quanto sua pele afetou qualquer uma das suas atividades sociais ou de lazer na semana que passou?',
        },
        {
          key: 'dificuldade_esportes',
          text: 'Quão difícil foi para você praticar esportes durante a semana que passou',
        },
        {
          key: 'impedimento_trabalho_estudo_atual',
          text: 'Sua pele impediu que você fosse trabalhar ou estudar durante a semana que passou?',
          options: [
            { text: 'Sim', value: 3 },
            { text: 'Não', value: 0 },
            { text: 'Sem relevância', value: -1 },
          ],
        },
        {
          key: 'problema_relacao_parceiro_amigos_parentes',
          text: 'Quão problemática se tornou sua relação com o(a) parceiro(a), amigos próximos ou parentes, por causa de sua pele?',
        },
        {
          key: 'dificuldade_vida_sexual',
          text: 'Até que ponto sua pele criou dificuldades na sua vida sexual na semana que passou?',
        },
        {
          key: 'problema_tratamento_dermatologico',
          text: 'Até que ponto seu tratamento dermatológico criou problemas para você durante a semana que passou?',
        },
      ],
      bindedQuestions: [
        {
          key: 'impedimento_trabalho_estudo_passado',
          bindedToKey: 'impedimento_trabalho_estudo_atual',
          answerToBindedQuestionValue: 0,
          text: 'Em caso negativo, sua pele já foi problema para você no trabalho ou na vida escolar?',
          options: [
            { text: 'Bastante', value: 2 },
            { text: 'Um pouco', value: 1 },
            { text: 'Nada', value: 0 },
          ],
        },
      ],
      defaultDlqiOptions: [
        { text: 'Realmente muito', value: 3 },
        { text: 'Bastante', value: 2 },
        { text: 'Um pouco', value: 1 },
        { text: 'Nada', value: 0 },
      ],
      /** @type {Record<string, {text: string, value: number}>} */
      answers: {},
    }
  },
  watch: {
    answers: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.$nextTick(() => {
          this.$emit('update:valid', this.verifyValid())
        })

        const objArr = [
          {
            name: 'DLQI',
            max: 30,
            min: 0,
            value: this.calculateScore(),
            sections: [
              {
                limit: 10,
                name: 'Leve',
                color: '#5c9219',
              },
              {
                limit: 30,
                name: 'Moderado a grave',
                color: '#b3261e',
              },
            ],
          },
        ]
        this.$emit('input', objArr)
        this.$emit('calculate', newVal)
      },
    },
  },
  methods: {
    getQuestionOptions(questionKey) {
      const question = this.questions.concat(this.bindedQuestions).find(({ key }) => key === questionKey)
      if (!question) {
        return []
      }

      return question.options ?? this.defaultDlqiOptions
    },
    verifyBindedQuestion(questionKey) {
      return isEqual(this.findBindedQuestion(questionKey)?.answerToBindedQuestionValue ?? {}, this.answers[questionKey])
    },
    verifyValid() {
      return Object.entries(this.answers)
        .filter(([key, _value]) => !!this.$el.querySelector(`[name=${key}]`))
        .every(([_key, value]) => !isNil(value))
    },
    handleBindedQuestionOnChange(questionKey, liIndex) {
      const bindedQuestion = this.findBindedQuestion(questionKey)

      this.$nextTick(() => {
        if (bindedQuestion && !isEqual(bindedQuestion.answerToBindedQuestionValue, this.answers[questionKey])) {
          this.answers[bindedQuestion.key] = null
        }
      })
    },
    findBindedQuestion(key) {
      return this.bindedQuestions.find((bdQuestion) => bdQuestion.bindedToKey === key)
    },
    defaultAnswers() {
      if (Object.keys(this.fillData).length > 0) {
        this.answers = this.fillData
        return
      }

      this.questions.forEach((question) => {
        this.$set(this.answers, question.key, null)
      })

      this.bindedQuestions.forEach((question) => {
        this.$set(this.answers, question.key, null)
      })
    },
    clear() {
      this.defaultAnswers()
    },
    calculateScore() {
      return sum(Object.values(this.answers).filter((number) => number >= 0))
    },
    getCalculatorData() {
      const data = {
        dlqi: {
          dlqi: {
            value: this.calculateScore(),
          },
          resultado_manual: false,
          profile: {},
        },
      }

      Object.keys(this.answers).forEach((key) => {
        const answer = this.answers[key]
        if (answer) {
          set(data, ['dlqi', 'profile', key], { text: answer.text, value: answer.value })
        }
      })

      return data
    },
  },
  created() {
    this.defaultAnswers()
  },
}
</script>

<style scoped>
:deep(.v-radio .v-icon),
:deep(.v-radio .v-input--selection-controls__ripple) {
  color: var(--v-primary-base);
}

ol {
  padding: 0;
}
ol > li {
  padding-bottom: 24px;
  margin-bottom: 24px;
  list-style-type: none;
}

.list-number {
  letter-spacing: 0.15px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin-right: 8px;
}
ol > li:not(:last-child) {
  border-bottom: 1px solid #e6e6e6;
}

.question {
  color: var(--v-neutral-lighten17);
  font-size: 16px;
  letter-spacing: 0.5px;
}

.ol-tilte {
  color: #383838;
  font-size: 22px;
  margin-bottom: 24px;
}
.v-input--radio-group :deep(.v-input__control .v-input__slot .v-input--radio-group__input .v-radio label) {
  font-size: 14px;
  letter-spacing: 0.25px;
  color: var(--v-neutral-lighten17);
}

.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
  margin-bottom: 12px;
}

@media screen and (min-width: 960px) {
  ol > li {
    padding-bottom: 32px;
  }
}
</style>
